import { IconButton, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import SwapHoriz from '@mui/icons-material/SwapHoriz';
import type { FieldElement } from '../../format/form-definition';
import type { Reference } from '../../format/pieces';
import { FieldIcon } from './FieldIcon';
import { fieldName } from './shared';

interface SwapMenuProps {
  title: string;
  label?: string;
  anchor: HTMLElement | null;
  onAnchor: (anchor: HTMLElement | null) => void;
  plain: string;
  offersToday: boolean;
  fields: FieldElement[];
  reference: Reference | undefined;
  onPick: (reference: Reference | undefined) => void;
}

export const SwapMenu = (props: SwapMenuProps) => {
  const { title, label, anchor, onAnchor, plain, offersToday, fields, reference, onPick } = props;
  if (!offersToday && fields.length === 0) return null;
  const pick = (next: Reference | undefined) => {
    onAnchor(null);
    onPick(next);
  };
  return (
    <>
      <Tooltip title={title} placement="left" disableInteractive>
        <IconButton aria-label={label ?? title} aria-haspopup="menu" onClick={event => onAnchor(event.currentTarget)}>
          <SwapHoriz fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={() => onAnchor(null)}>
        <MenuItem selected={!reference} onClick={() => (reference ? pick(undefined) : onAnchor(null))}>
          {plain}
        </MenuItem>
        {offersToday && (
          <MenuItem selected={reference?.kind === 'today'} onClick={() => pick({ kind: 'today' })}>
            Today
          </MenuItem>
        )}
        {fields.length > 0 && <ListSubheader>The value of another field</ListSubheader>}
        {fields.map(field => (
          <MenuItem
            key={field.id}
            selected={reference?.kind === 'fieldValue' && reference.fieldId === field.id}
            onClick={() => pick({ kind: 'fieldValue', fieldId: field.id })}
            sx={{ whiteSpace: 'normal' }}
          >
            <ListItemIcon>
              <FieldIcon field={field} fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={fieldName(field)} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
